/**
 * Add or Remove state for collection or app add / remove buttons
 */
export enum AddRemoveState {
  ADD = "ADD",
  REMOVE = "REMOVE",
}
